<template>
  <div class="pages flex-direction-box">
    <div class="g-companyTop flex-box">
      <div class="g-user-info flex-box">
        <div class="g-user-img">
          <img v-if="mhManagerHeadThumb" :src="mhManagerHeadThumb" alt="">
          <img v-else src="../assets/img/userhead.png" alt="">
        </div>
        <div class="g-user-basic">
          <h4>{{companyName|empty}}</h4>
          <p><span>{{mhManagerName|empty}}</span>{{mhRoleName|empty}}</p>
        </div>
      </div>
      <div class="flex-box g-info-box" style="height: 100%;">
        <div class="g-info-item" style="border-left: 0;">
          <p class="p1">{{systemNum|empty}}</p>
          <p class="p2">我的申请变更</p>
          <el-button size="mini" round @click="goJumpPages('message_notify',1)">查看</el-button>
        </div>
        <div class="g-info-item">
          <p class="p1" style="color: #333;">{{backlogNum|empty}}</p>
          <p class="p2">我的待办事项</p>
          <el-button size="mini" round @click="goJumpPages('file_upload_manager',2)">查看</el-button>
        </div>
        <div class="g-info-item">
          <p class="p1">{{needCheckNum|empty}}</p>
          <p class="p2">人员注册待审核</p>
          <el-button size="mini" round @click="goJumpPages('user_manager',3)">查看</el-button>
        </div>
        <div class="g-info-item">
          <p class="p1">{{unreadNum|empty}}</p>
          <p class="p2">我的未读通知</p>
          <el-button size="mini" round @click="goJumpPages('park_notice_manager',)">查看</el-button>
        </div>
      </div>
    </div>
    <div class="flex-box g-remindsbox" style="flex: 1;">
      <div class="g-reminds-item" style="flex: 40;">
        <div class="g-reminds-tit flex-box">
          <p class="tit-left flex-box">
            <img src="../assets/img/remind.png" alt="" class="img-icon"
                 style="width: 20px;height: 21px;margin-right: 10px">
            工作提醒
          </p>
          <p class="tit-right" v-if="$checkPermissions('message_notify')"
             @click="$router.push('/messageNotification')">
            <img src="../assets/img/more.png" alt="" class="img-more-icon"
                 style="width: 20px;height: 21px;margin-right: 5px"/>
            查看更多</p>
        </div>
        <div style="overflow: auto; height: calc(100% - 42px);">
          <div class="g-nodata" v-if="messageList.length == 0">
            <img src="../assets/img/nodata.png" alt="">
            <p>当前暂无提醒</p>
          </div>
          <div class="g-notice-cont" style="flex: 1;overflow-y: auto;overflow-x: hidden;" v-else>
            <div class="g-notice-item flex-box" v-for="(item,key) in messageList" :key="key" v-if="key<4"
                 @click="onDetail(item)">
              <img v-if="item.messageIsRead==0" class="weiduimg" src="../assets/img/thumbtack.png" alt=""
                   style="margin-right: 5px;"/>
              <div :class="item.messageIsRead == 1?'g-fullwidth':'g-nowidth'">
                <div class="flex-box g-notice-tit">
                  <h4 class="ellipsis" :title="item.messageTitle"
                      :class="item.messageIsRead == 1?'g-fullwidth':'g-nowidth'"
                      style="margin-top: 0; width: calc(100% - 130px);">
                    {{item.messageTitle|empty}}</h4>
                  <p class="p-times">{{item.messageCreateTime|datetimeType("yyyy-MM-dd hh:mm")}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="g-reminds-item" style="flex: 60;margin-left: 20px;">
        <div class="g-reminds-tit flex-box">
          <p class="tit-left flex-box">
            <img src="../assets/img/apply.png" alt="" class="img-icon"
                 style="width: 20px;height: 21px;margin-right: 10px">
            快捷入口
          </p>
        </div>
        <div class="g-nodata" v-if="!shortcutEntry.length">
          <img src="../assets/img/nodata.png" alt="">
          <p>当前暂无快捷入口，请联系园区管理员配置</p>
        </div>
        <div class="g-notice-cont" style="height: calc(100% - 60px);" v-else>
          <ul class="wh100 g-worker-list" style="overflow: auto;">
            <li class="g-worker-item flex-box" v-for="(item,index) in shortcutEntry" :key="index"
                @click="onApplyNow(item,index)"
                style="cursor: pointer;min-height: 120px;max-height: calc(50% - 9px);position: relative;">
              <img v-if="item.entranceIcon" :src="item.entranceIcon" alt="图片不见了" class="worker-img"/>
              <img v-else src="../assets/img/u14842.png" class="worker-img"/>
              <div style="margin-left: 10px;overflow: hidden;">
                <h3 class="title ellipsis2" :title="item.entranceTitle">{{item.entranceTitle}}</h3>
                <span v-if="item.entranceType===2" class="shortcut-btn">查 看</span>
                <span v-else-if="item.fixedOptionType===2" class="shortcut-btn">查 看</span>
                <span v-else class="shortcut-btn">发 起</span>
              </div>
              <div class="f-enter-type" v-if="item.entranceType!==1" :class="getColorType(item.entranceType)">
                {{item.entranceType===2?"服务对接":"工作流"}}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex-box g-remindsbox" style="flex: 1;margin-top: 20px;">
      <div class="g-reminds-item flex-direction-box" style="flex: 40;">
        <div class="g-reminds-tit flex-box">
          <p class="tit-left">
            <img src="../assets/img/backlog.png" alt="" class="img-icon">
            待办事项
          </p>
          <p class="tit-right" v-if="$checkPermissions('file_upload_manager')"
             @click="$router.push('/fileUploadManage')">
            <img src="../assets/img/more.png" alt="" class="img-more-icon"/>
            查看更多</p>
        </div>
        <div class="g-nodata" v-if="matterCompaniesList.length == 0">
          <img src="../assets/img/nodata.png" alt="">
          <p>当前暂无事项</p>
        </div>
        <div class="g-remind-cont" v-else style="overflow: auto; height: calc(100% - 61px);">
          <div class="g-cont-item flex-box"
               :class="(item.matterCompanyStatus == 0||item.matterCompanyStatus == 1)?'c-ingcolor':''"
               v-for="(item,key) in matterCompaniesList" :key="key" v-if="key<4">
            <div class="g-item-left">
              <div class="g-something flex-box">
                <p class="g-type ellipsis" :title="item.matterTypeName">{{item.matterTypeName|empty}}</p>
                <h4 class="ellipsis">{{item.matterName|empty}}</h4>
              </div>
              <div class="flex-box g-contact-info">
                <p><img src="../assets/img/u14.png" alt="">
                  {{item.adminName|empty}}
                </p>
                <p><i class="el-icon-time"></i>
                  {{item.matterCompanyCreateTime|datetimeType("yyyy-MM-dd hh:mm")}}
                </p>
              </div>
            </div>
            <el-button class="g-btn1" size="small" @click="handle(item,key)"
                       v-if="(item.matterCompanyStatus == 0 || item.matterCompanyStatus == 1)&& $checkPermissions('file_upload_manager')">
              处理
            </el-button>
            <el-button v-if="item.matterCompanyStatus == 2|| item.matterCompanyStatus == 3" class="g-btn1" size="small"
                       @click="editThing(item,key)">
              查看记录
            </el-button>
          </div>
        </div>
      </div>
      <div class="wh100" style="display: flex;flex: 60;margin-left: 20px;overflow: hidden;">
        <div class="g-reminds-item flex-direction-box" style="flex: 1;">
          <div class="g-reminds-tit flex-box">
            <p class="tit-left flex-box">
              <img src="../assets/img/remind.png" alt="" class="img-icon"
                   style="width: 20px;height: 21px;margin-right: 10px">
              园区公告
            </p>
            <p class="tit-right" v-if="$checkPermissions('file_upload_manager')"
               @click="$router.push('/notification')">
              <img src="../assets/img/more.png" alt="" class="img-more-icon"
                   style="width: 20px;height: 21px;margin-right: 5px"/>
              查看更多</p>
          </div>
          <div style="overflow: auto; height: calc(100% - 42px);">
            <div class="g-nodata" v-if="noticeList.length == 0">
              <img src="../assets/img/nodata.png" alt="">
              <p>当前暂无公告</p>
            </div>
            <div class="g-notice-cont" style="flex: 1;overflow-y: auto;overflow-x: hidden;" v-else>
              <div class="g-notice-item"
                   style="display: flex;flex-direction: column;justify-content: center;padding-top: 5px;"
                   v-for="(item,key) in noticeList" :key="key" v-if="key<6"
                   @click="lookDetails(item,key)">
                <div class="flex-box">
                  <img v-if="item.notifyIsRead==0" class="weiduimg" src="../assets/img/thumbtack.png" alt=""
                       style="margin-right: 4px;"/>
                  <div :class="item.notifyIsRead == 1?'g-fullwidth':'g-nowidth'">
                    <div class="flex-box g-notice-tit">
                      <p class="ellipsis" :title="item.notifyName" style="width: calc(100% - 130px);">
                        {{item.notifyName}}</p>
                      <p class="p-times">{{item.notifyCreateTime|datetimeType("yyyy-MM-dd hh:mm")}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="g-reminds-item flex-direction-box" style="flex: 1;margin-left: 20px;">
          <div class="g-reminds-tit flex-box">
            <p class="tit-left">
              <img src="../assets/img/examine.png" alt="" class="img-icon" style="width: 30px;height: 24px;"/>
              注册审核</p>
            <p class="tit-right" v-if="$checkPermissions('user_manager')" @click="$router.push('/peopleManage')">
              <img src="../assets/img/more.png" alt="" class="img-more-icon"/>
              查看更多</p>
          </div>
          <div class="g-nodata" v-if="examineList.length == 0">
            <img src="../assets/img/nodata.png" alt="">
            <p>当前暂无注册审核信息</p>
          </div>
          <div class="g-remind-cont" v-else style="flex: 1;">
            <div class="g-cont-item flex-box g-examine-item" :class="item.userConfirmState ===2?'c-ingcolor':''"
                 v-for="(item,key) in examineList" :key="key" v-if="key<5">
              <div class="g-item-left">
                <div class="g-something flex-box" style="justify-content: space-between;max-width: 450px;">
                  <p class="text-left ellipsis" style="width: 90px;font-size: 12px;" :title="item.userName">
                    <img src="../assets/img/user.png" alt="" class="user-img"/>
                    {{item.userName}}
                  </p>
                  <p class="ellipsis" :title="item.userMobile" style="font-size: 12px;">{{item.userMobile}}</p>
                  <p class="text-center" style="font-size: 12px;">
                    {{(item.userRegister && item.userRegister != "null")? Number(item.userRegister): ""
                    |datetimeType("yyyy-MM-dd hh:mm")}}
                  </p>
                </div>
              </div>
              <div class="text-right" style="width: 75px;">
                <div v-if="item.userConfirmState === 2">
                  <el-button class="g-examine examine-btn" size="mini" v-if="$checkPermissions('user_manager')"
                             @click="examine(item,key,2)" round>审 核
                  </el-button>
                </div>
                <p v-else style="margin-right: 20px;font-size: 12px;">
                  <el-button class="examine-btn" v-if="item.userConfirmState===3" size="mini" round>已通过
                  </el-button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="服务详情" class="append-body" :visible.sync="serverDetailDialog" :append-to-body="true"
               width="750px" center top="3%" :close-on-click-modal="false">
      <v-sever-detail v-if="serverDetailDialog" :serveId="serveId"
                      @closeDialog="serverDetailDialog=false"></v-sever-detail>
    </el-dialog>
    <el-dialog title="事项处理" :visible.sync="accountDialog" width="50%" center top="3%">
      <div class="dialog_warp">
        <div class="dialog_form">
          <div class="g-thing-tit">
            <h4>{{matterInfo.matterName}}</h4>
            <div class="flex-box">
              <p>事项类型：资料上传</p>
              <p>发起人：{{matterInfo.adminName}}</p>
              <p>发起时间：{{matterInfo.matterCreateTime|datetimeType("yyyy-MM-dd hh:mm")}}</p>
            </div>
            <div class="thingstate">待处理</div>
          </div>
          <p class="g-contp">{{matterInfo.matterDes}}</p>
        </div>

        <div class="g-uploadimgbox">
          <el-upload
            class="upload-demo" drag action="/company/matterCompany/receiveFile" multiple
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload1"
            :on-exceed="handleExceed"
            :limit="5"
            :fileList="fileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </div>
        <div class="text-center">
          <p style="margin-top: 10px;">
            <el-button size="small" type="success" @click="accountDialog=false">取消</el-button>
            <el-button size="small" type="success" :loading="handleLoading" @click="addHandle(1)">处理</el-button>
          </p>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="事项编辑" :visible.sync="editDialog" width="50%" center top="3%">
      <div class="dialog_warp">
        <div class="dialog_form">
          <div class="g-thing-tit">
            <h4>{{matterInfo.matterName}}</h4>
            <div class="flex-box">
              <p>事项类型：文件上传</p>
              <p>发起人：{{matterInfo.adminName}}</p>
              <p>发起时间：{{matterInfo.matterCreateTime|date}}</p>
            </div>
            <div class="thingstate c-blue">已处理</div>
          </div>
          <p class="g-contp">{{matterInfo.matterDes}}</p>
        </div>
        <div class="g-downbox" v-if="matterCompanyFileList.length > 0">
          <div class="flex-box g-dowm-item" v-for="(item,key) in matterCompanyFileList" :key="key">
            <p class="g-filename ellipsis">{{item.matterCompanyFileName}}</p>
            <p class="g-filetime">{{item.matterCompanyFileCreateTime|datetime}}</p>
            <i class="el-icon-download" @click="download(item.matterCompanyFileUrl,item.matterCompanyFileId)"></i>
            <i class="el-icon-delete" @click="delfile(item)"></i>
          </div>
        </div>
        <el-upload
          class="upload-demo" drag action="/company/matterCompany/receiveFile" multiple
          :on-success="handleAvatarSuccess"
          :on-remove="handleRemove"
          :before-upload="beforeAvatarUpload2"
          :on-exceed="handleExceed2"
          :limit="5 - matterCompanyFileList.length"
          :fileList="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div class="text-center">
          <p style="margin-top: 10px;">
            <el-button size="small" @click="editDialog=false">取消</el-button>
            <el-button size="small" type="success" :loading="handleLoading" @click="addHandle(2)">确认</el-button>
          </p>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="事项详情" class="append-body" :visible.sync="matterDetailDialog" :append-to-body="true"
               width="700px" center top="3%">
      <v-form-detail v-if="matterDetailDialog" :type="matterCompanyStatus" :matterId="matterId"
                     :matterCompanyId="matterCompanyId" @closeDialog="matterDetailDialog=false"
                     @init="matterInit"></v-form-detail>
    </el-dialog>
    <el-dialog title="事项处理" class="append-body" :visible.sync="matterHandleDialog" :append-to-body="true"
               width="700px" center top="3%">
      <v-form-handle v-if="matterHandleDialog" :type="matterCompanyStatus" :matterId="matterId"
                     :matterCompanyId="matterCompanyId" @closeDialog="matterHandleDialog=false"
                     @init="matterInit"></v-form-handle>
    </el-dialog>


    <el-dialog title="园区公告详情" :visible.sync="detailsDialog" width="750px" center top="3%">
      <v-notification-details v-if="detailsDialog" @closeDialog="detailsDialog = false" :notifyId="notifyId" @init="indexDateInit();noticeInit();detailsDialog = false;"></v-notification-details>
    </el-dialog>

    <el-dialog :visible.sync="detailVisible" @closed="onDetailClose" class="g-message-info">
      <i class="iconfont icon-lajixiang" slot="title" style="margin-left: 10px;" @click="onDetailDelete"></i>
      <div class="g-wrap">
        <div class="g-title">{{getMessage.messageTitle}}</div>
        <div class="s-read">发件人：{{getMessage.messageTypeDes}}</div>
        <div class="s-read">时间：{{getMessage.messageCreateTime}}</div>
      </div>
      <div class="g-wrap">
        <div v-if="">
          {{getMessage.messageBody}} <span class="f-detail-link"
                                           @click="onItemDetail(getMessage.messageToId)">点击查看详情</span>
        </div>
      </div>
      <div class="g-wrap">
        <div v-if="getMessage.fileList ? (getMessage.fileList.length === 0 ? true : false) : true">无附件</div>
        <div v-else v-for="(item, index) in getMessage.fileList" :key="index" @click="onDownLoad(item.messageFileUrl)"
             class="f-detail-link">{{item.messageFileName}}
        </div>
      </div>
      <div class="g-wrap">
        <div>下一条 <span class="f-detail-link" :class="{'f-last-title': isLastTitle}" @click="onNextMessage">{{chooseItemNextTitle}}</span>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="itemDetailVisible" @closed="onItemDetailClose" class="g-min-width" title="审批详情">
      <div class="g-content-wrap">
        <div class="c-box-shadow g-padding-size g-overflow">
          <el-steps direction="vertical" :active="getProgressActive" finish-status="success">
            <el-step v-for="(item, index) in processList" :key="index">
              <div slot="description" class="ellipsis3">
                <div v-if="item.workflowApplicationProcessStatus">{{item.processRecord.doName}}</div>
                <div v-if="!item.workflowApplicationProcessStatus" v-for="(option) in item.operands">{{option}}</div>
                <div v-if="item.workflowApplicationProcessStatus">{{item.processRecord.doTime}}</div>
                <div v-if="item.workflowApplicationProcessStatus">
                  {{item.processRecord.workflowApplicationProcessRecordDes}}
                </div>
                <div class="down-item flex-box" v-for="(itemfile,indexs) in item.processRecord.files" :key="indexs">
                  <span class="ellipsis" style="width:120px;">{{itemfile.workflowFileName|empty}}</span>
                  <i class="el-icon-download icon"  @click="downLoadWorkFile(itemfile)"></i>
                </div>
              </div>
            </el-step>
          </el-steps>
        </div>

        <div class="g-right">
          <div class="g-right-top">
            <div class="flex-box">
              <i class="iconfont icon-shenqing"></i>
              <h3 class="c-title">{{workflow.workflowType}}</h3>
            </div>
            <div class="g-right-top-desc" style="">
              {{workflow.workflowDes}}
            </div>
          </div>
          <div class="g-right-bottom" style="">
            <div class="g-header">
              <div class="c-title">
                {{workflowApplication.workflowApplicationTitle}}
              </div>
              <div class="flex-box" style="margin:10px 0;">
                <div class="create-person" style="margin-right: 20px;">发起人：{{workflowApplication.managerName}}</div>
                <div class="company">所属企业：{{workflowApplication.companyName}}</div>
              </div>
              <div class="create-time" style="">
                发起时间：{{workflowApplication.workflowApplicationCreateTime}}
              </div>
            </div>
            <div class="g-body">
              <div class="content" style="min-height: 100px;overflow: hidden;width: 100%;">
                {{workflowApplication.workflowApplicationDes}}
              </div>
              <div class="g-footer flex-box" style="width:100%;" v-if="fileList && fileList.length">
                <div style="margin-right:20px;align-self: flex-start;">附件：</div>
                <div class="g-flex-right">
                  <div class="flex-box" style="max-height: 100px;overflow-y: auto;flex-direction: column;width: 100%;"
                       v-if="(fileList && fileList.length > 0) ? (fileList[0].workflowApplicationFileName ? true : false) : false">
                    <div class="carry-file" v-for="(item, index) in fileList" :key="index">
                      <div class="flex-box">
                        <div class="g-fileName">{{item.workflowApplicationFileName}}</div>
                        <i class="el-icon-download" @click="download(item)"></i>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"v-if="workflowApplication.workflowApplicationStatus == 1" @click="onConfirm">确 定</el-button>
        <el-button @click="cancel">返 回</el-button>
      </div>
    </el-dialog>

    <el-dialog center title="认证审核" class="g-form-box" :visible.sync="formVisible" center width="500px">
      <el-form :model="formData" ref="formData" size="mini" label-width="90px" label-position="left">
        <div style="padding:25px 25px 30px;">
          <div style="margin-bottom:20px;">信息填写：</div>
          <div class="flex-box" style="">
            <el-form-item label="人员姓名" prop="userName">
              <el-input v-model.trim="formData.userName" auto-complete="off" placeholder="请输入人员姓名..." class="input-box"
                        :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="userMobile" style="margin-left:20px;">
              <el-input v-model.trim="formData.userMobile" auto-complete="off" placeholder="请输入联系方式..."
                        class="input-box" :disabled="true"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="人员权限">
            <el-radio v-model="formData.userPermission" :label="1">企业员工</el-radio>
            <el-radio v-model="formData.userPermission" :label="2">企业管理员</el-radio>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" class="g-danger" @click="onConfirmRefuse">驳 回</el-button>
        <el-button size="mini" type="primary" @click="onConfirmPass" :loading="confirmPassLoading">确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog center title="认证驳回" class="g-fail-box" :visible.sync="refuseVisible" center width="300px" top="20%">
      <div style="padding:25px 25px 30px;">
        <div style="text-align: center;">该操作将驳回此申请,是否确认?</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="refuseVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="onConfirmRefuse">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="问题反馈添加" :visible.sync="problemAddDialog" width="750px" center top="3%">
      <problem-add v-if="problemAddDialog" @closeDialog="problemAddDialog=false;"></problem-add>
    </el-dialog>
  </div>
</template>
<script>
  import * as getData from "../service/getData";
  import * as global from "../config/mUtils";
  import problemAdd from "./信息反馈/问题反馈添加.vue";

  export default {
    data() {
      return {
        problemAddDialog: false,
        accountDialog: false,
        detailsDialog: false,
        matterDetailDialog: false,
        matterHandleDialog: false,
        serverDetailDialog: false,
        serveId: "",
        matterCompanyStatus: "",
        matterId: "",
        matterCompanyId: "",
        noticeList: [],
        currUser: {},
        backlogNum: "",
        needCheckNum: "",
        systemNum: "",
        unreadNum: "",
        matterCompaniesList: [],
        matterInfo: {},
        notifyInfo: {},
        handleLoading: false,
        refuseVisible: false,
        formVisible: false,
        confirmPassLoading: false,

        processList: [],
        workflow: {},
        workflowApplication: {},
        fileList: [],//提交的文件列表数组数据
        itemDetailVisible: false,//查看项目详情显隐控制

        detailVisible: false,//查看消息详情显隐控制
        chooseTypeId: 0,//当前所选中消息类型id
        chooseItem: "",//点击详情所选中的项目
        isOnDetail: false,//是否点击详情页，点击删除icon时使用，以便于隐藏对话框
        chooseItemIndex: 0,//当前详情在messageList中的index值,以便于点击详情中下一条消息时计算索引，+1即可
        chooseItemNextTitle: "",//详情页下一个消息标题
        isLastTitle: false,//详情页消息标题是否为最后一个

        matterCompanyFileList: [],
        mhRoleName: "",
        companyName: "",
        mhManagerHeadThumb: "",
        mhManagerName: "",
        asideList: [
          {
            name: "园区公告",
            id: 1
          },
          {
            name: "系统通知",
            id: 2
          }
        ],
        activeId: 1,
        examineList: [],
        shortcutEntry: [],
        editDialog: false,
        messageList: [],
        formData: {//认证通过表单数据
          userName: "",
          userMobile: "",
          userPermission: 1
        },
        getMessage: {
          messageTitle: "",
          messageTypeDes: "",
          messageCreateTime: "",
          getMessage: ""
        },
        notifyId: '',
      };
    },
    created() {
    },
    components: {
      problemAdd
    },
    computed: {
      getProgressActive() {//根据接口返回数据设置步骤条当前状态
        let status = 0;
        for (let i = 0; i < this.processList.length; i++) {
          if (this.processList[i].workflowApplicationProcessStatus) {
            status++;
          }
        }
        return status;
      }
    },
    mounted() {
      this.noticeInit();
      /*园区通知*/
      this.message();
      /*工作提醒*/
      this.indexDateInit();
      /*header*/
      this.matterInit();
      /*我的事项*/
      this.getCompanyList();
      /*注册审核*/
      this.findEntranceByChannel();
      /*快捷入口*/
    },
    methods: {
      getColorType(val) {
        switch (val) {
          case 2:
            return "f-green";
          case 3:
            return "f-blue";
          default:
            return val;
        }
      },
      downloadFile(row, index) {
        if (!row.notifyFileUrl || !row.notifyFileName) {
          this.$message({
            type: "warning",
            message: "下载地址不存在！"
          });
          return;
        }
        if (row.notifyFileId) {
          window.location.href = `/company/notify/downloadFile?notifyFileId=${row.notifyFileId}`;
        } else {
          window.location.href = `/company/notify/downloadFile?notifyFileUrl=${row.notifyFileUrl}&notifyFileName=${row.notifyFileName}`;
        }
      },
      downLoadWorkFile(file){
       window.open('/company/download/downloadWorkflowFileUseName?fileName='+file.workflowFileName+'&fileUrl='+file.workflowFileUrl)
      },
      checkUndefined(val) {
        switch (val) {
          case undefined:
          case "undefined":
          case null:
          case "null":
          case "":
            return "";
          default:
            return val;
        }
      },
      goJumpPages(permissionVal,type){
        if (this.$checkPermissions(permissionVal)) {
          if(type == 1){
            this.$router.push('/messageNotification');
          }else if(type == 2){
            this.$router.push('/fileUploadManage');
          }else if(type == 3){
            this.$router.push('/peopleManage');
          }else if(type == 4){
            this.$router.push('/notification');
          }
        } else {
          this.$message.warning("抱歉！你没有该权限！");
        }
      },
      onApplyNow(row, index) {
        if (row.entranceType === 1) {
          if (row.permissionVal) {
            if (this.$checkPermissions(row.permissionVal)) {
              if (row.fixedOptionType === 1) {
                this.problemAddDialog = true;
              } else {
                this.$router.push({path: row.entranceUrl, query: {type: 1}});
              }
            } else {
              this.$message.warning("抱歉！你没有该权限！");
            }
          }
        } else if (row.entranceType === 2) {
          if (this.$checkPermissions("serve_list")) {
            this.serveId = row.entranceCurrId;
            this.serverDetailDialog = true;
          } else {
            this.$message.warning("抱歉！你没有该权限！");
          }
        } else if (row.entranceType === 3) {
          if (this.$checkPermissions("add_workflow")) {
            this.$store.state.applyItem = row.workflowVO;
            this.$router.push({path: "/addApplication", query: {type: 1, index: index}});
          } else {
            this.$message.warning("抱歉！你没有该权限！");
          }
        }
      },
      activeNotice(row, index) {
        this.activeId = row.id;
        if (row.id === 2) {
          this.message();
        } else {
          this.noticeInit();
        }
      },
      onDetail(item) {
        if (this.$checkPermissions('message_notify')) {
          this.chooseItem = item;
          console.log(item);
          this.isOnDetail = true;
          getData.getMessage(item.messageId).then(res => {
            if (res.data.code === "success") {
              this.getMessage = res.data.data.message;
              this.messageList.forEach(listItem => {
                if (listItem.messageId === item.messageId) {
                  let index = this.messageList.indexOf(listItem);
                  this.chooseItemIndex = index;
                  if (index < this.messageList.length - 1) {
                    this.isLastTitle = false;
                    this.chooseItemNextTitle = this.messageList[index + 1].messageTitle;
                  } else {
                    this.isLastTitle = true;
                    this.chooseItemNextTitle = "没有更多的消息";
                    console.log(this.isLastTitle);
                  }
                }
              });
              this.detailVisible = true;
            }
          });
        } else {
          this.$message.warning("抱歉！你没有该权限！");
        }
        
      },
      onDetailClose() {
        this.isOnDetail = false;
        this.message();
        this.indexDateInit();
      },
      onDetailDelete() {
        this.onDelete(this.chooseItem);
      },
      onDownLoad(url) {
        window.open(url);
      },
      onNextMessage() {
        if (this.chooseItemIndex === this.messageList.length - 1) {
          this.$message.info("已经是最后一条消息");
        } else {
          let nextItem = this.messageList[this.chooseItemIndex + 1];
          this.onDetail(nextItem);
        }
      },
      onDelete(item) {
        this.$confirm("确定删除？", "提示", {
          confirmButtonText: "确定",
          cancleButtonText: "取消",
          type: "warning"
        }).then(() => {
          getData.deleteMessage(item.messageId).then(res => {
            if (res.data.code === "success") {
              this.$message({
                type: "success",
                message: "删除成功！"
              });
              if (this.isOnDetail === true) {
                this.isOnDetail = false;
                this.detailVisible = false;
              }
              this.message();
              this.indexDateInit();
            } else {
              this.$message.info("删除失败");
            }
          });
        }).catch(_ => {
        });
      },
      onItemDetail(itemId) {// 控制项目具体细节
        // getData.getWorkflowApplication(itemId).then(res => {
        //   if (res.data.code === "success") {
        //     this.processList = res.data.data.processList;
        //     this.workflow = res.data.data.workflow;
        //     this.workflowApplication = res.data.data.workflowApplication;
        //     this.fileList = res.data.data.fileList;
        //     this.itemDetailVisible = true;
        //   } else {
        //     this.$message.info("数据获取失败！");
        //   }
        // });
        this.$router.push(this.getMessage.route)
      },
      onItemDetailClose() {
        this.processList = [];
        this.workflow = {};
        this.workflowApplication = {};
        this.fileList = [];
        this.itemDetailVisible = false;
      },
      onConfirm() {
        this.$confirm("是否确认该申请流程已完成？", "", {
          confirmButtonText: "确定",
          cancleButtonText: "取消",
          type: "warning"
        }).then(() => {
          getData.workflowApplicationSure(id).then(res => {
            if (res.data.code === "success") {
              this.$message({
                type: "success",
                message: "确认成功！"
              });
              this.init();
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
            }
          });
        });
        this.onItemDetailClose();
      },
      cancel(){
        this.onItemDetailClose();
      },
      examine(row, index, type) {
        this.userId = row.userId;
        // this.onConfirmPass();
        this.formData.userName = row.userName;
        this.formData.userMobile = row.userMobile;
        this.userPostionState = row.userPostionState;
        this.formVisible = true;
      },
      noticeInit() {
        getData.listNotify(1, 10, "", "").then(res => {
          if (res.data.code == "success") {
            this.noticeList = res.data.data.list ? res.data.data.list : [];
          }
        });
      },
      indexDateInit() {
        getData.indexDate().then(res => {
          if (res.data.code == "success") {
            let datas = res.data.data;
            this.companyName = datas.companyName;
            this.mhManagerHeadThumb = this.checkUndefined(datas.mhManagerHeadThumb);
            this.backlogNum = datas.BacklogNum;
            this.needCheckNum = datas.needCheckNum;
            this.systemNum = datas.systemNum;
            this.unreadNum = datas.unreadNum;
            this.mhManagerName = datas.mhManagerName;
            this.mhRoleName = datas.mhRoleName;
          }
        });
      },
      message() {
        getData.messageList(1, 10, 0).then(res => {
          if (res.data.code === "success") {
            this.messageInfoData = res.data.data;
            this.messageList = res.data.data.messageList;
          }
        });
      },
      matterInit() {
        getData.listMatterCompany(1, 10, "", "", "").then(res => {
          if (res.data.code == "success") {
            this.matterCompaniesList = res.data.data.matterCompanies ? res.data.data.matterCompanies : [];
          }
        });
      },
      handle(row, index) {
        // this.matterCompanyStatus = row.matterCompanyStatus;
        // this.matterCompanyId = row.matterCompanyId;
        // this.matterId = row.matterCompanyId;
        // this.matterHandleDialog = true;
        this.$router.push({
          path: "/fileHandle", query: {
            type: 0,
            matterCompanyId: row.matterCompanyId,
            matterId: row.matterCompanyId
          }
        });
      },
      editThing(row, index) {
        this.matterCompanyStatus = row.matterCompanyStatus;
        this.matterCompanyId = row.matterCompanyId;
        this.matterId = row.matterCompanyId;
        this.matterDetailDialog = true;
      },
      getfileList(matterCompanyId) {
        getData.listFilesByMatterCompanyId(matterCompanyId).then(res => {
          if (res.data.code == "success") {
            this.matterCompanyFileList = res.data.data.matterCompanyFileList;
            this.fileList = [];
            this.editDialog = true;
          }
        });
      },
      getCompanyList() {
        getData.mhUserList(1, 10, -1, "", "").then((res) => {
          if (res.data.code == "success") {
            this.examineList = res.data.data.list;
          }
        }).catch(_ => {

        });
      },
      findEntranceByChannel() {
        getData.findEntranceByChannel().then(res => {
          if (res.data.code === "success") {
            this.shortcutEntry = res.data.data.entranceList;
          }
        });
      },
      onConfirmRefuse() {
        getData.noPassMhUser(this.userId).then(res => {
          if (res.data.code === "success") {
            this.$message.success("驳回成功！");
            this.formVisible = false;
            this.getCompanyList();
          }
        });
      },
      onConfirmPass() {
        this.confirmPassLoading = true;
        getData.passMhUser(this.userId, this.formData.userPermission, this.formData.userMobile, this.formData.userName).then(res => {
          if (res.data.code === "success") {
            this.$message.success("通过成功！");
            this.formVisible = false;
            this.confirmPassLoading = false;
            this.getCompanyList();
          } else {
            this.$message.error("通过失败！");
          }
        });
      },
      handleAvatarSuccess(res, file, fileList) {
        //console.log(res, file, fileList,'success')
        this.fileList = fileList;
      },
      handleRemove(file, fileList) {
        //console.log(file, fileList,'resmove')
        this.fileList = fileList;
      },
      beforeAvatarUpload1(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error("上传文件大小不能超过 5MB!");
        }
        return isLt5M;
      },
      beforeAvatarUpload2(file) {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
          this.$message.error("上传文件大小不能超过 5MB!");
        }
        const is5Length = this.fileList.length + this.matterCompanyFileList.length < 5;
        if (!is5Length) {
          this.$message.error("当前限制选择 5  个文件");
        }
        return isLt5M && is5Length;
      },
      handleExceed(files, fileList) {
        //console.log(files.length,fileList.length,this.matterCompanyFileList.length,1231)
        this.$message.warning(`当前限制选择 5  个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleExceed2(files, fileList) {
        //console.log(files.length,fileList.length,this.matterCompanyFileList.length,1231)
        this.$message.warning(`当前限制选择 5  个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length + this.matterCompanyFileList.length} 个文件`);
      },
      addHandle(type) {
        this.handleLoading = true;
        if (this.fileList.length == 0 && type == 1) {
          this.$message({
            message: "请先添加文件！",
            type: "error"
          });
          this.handleLoading = false;
          return;
        }
        let datas = [];
        this.fileList.forEach((item) => {
          datas.push({
            matterCompanyFileName: item.name,
            matterCompanyFileUrl: item.response.data.fileUrl,
            matterCompanyFileMatterCompanyId: this.matterInfo.matterCompanyId
          });
        });
        getData.addMatterCompanyFile(datas).then(res => {
          this.fileList = [];
          if (res.data.code == "success") {
            if (type == 1) {
              this.second(type);
            }
            else {
              this.handleLoading = false;
              this.editDialog = false;
              this.matterInit();
              this.indexDateInit();
            }
          }
          else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
            this.handleLoading = false;
          }
        });
      },
      second(type) {
        getData.handleMatterCompany(this.matterInfo.matterCompanyId).then(res => {
          if (res.data.code == "success") {
            this.$message({
              message: "已经处理！",
              type: "success"
            });
            this.handleLoading = false;
            if (type == 1) {
              this.accountDialog = false;
            }
            else {
              this.editDialog = false;
            }
            this.matterInit();
            this.indexDateInit();
          }
          else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
            this.handleLoading = false;
          }
        });
      },
      lookDetails(row, index, type) {
        if (this.$checkPermissions('park_notice_manager')) {
          this.notifyId = row.notifyId
          this.detailsDialog = true;
        } else {
          this.$message.warning("抱歉！你没有该权限！");
        }
      },
      download(row) {
        if (!row.workflowApplicationFileId && row.workflowApplicationFileId !== 0) {
          this.$message({
            type: "warning",
            message: "下载地址不存在！"
          });
          return;
        }
        window.location.href = `/company/download/downloadWorkflowApplicationFile?workflowApplicationFileId=${row.workflowApplicationFileId}`;
      },
      delfile(row) {
        if (this.matterCompanyFileList.length == 1) {
          this.$message({
            type: "warning",
            message: "最后一个文件不能删除!"
          });
          return;
        }
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          getData.deleteMatterCompanyFile(row.matterCompanyFileId).then(res => {
            if (res.data.code == "success") {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getfileList(this.matterInfo.matterCompanyId);
            }
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });

      }
    }
  };
</script>
<style lang="scss" scoped>
  @import "../assets/css/mixin";

  .pages {
    background-color: #ebeef2;
    padding: 20px;
    min-height: 690px;
    box-sizing: border-box;
    overflow: auto;
  }

  .g-companyTop {
    @include wh(100%, 142px);
    background-color: #fff;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .g-user-info {
    .g-user-img {
      margin-left: 60px;
      margin-right: 30px;
      @include wh(80px, 80px);
      border-radius: 50%;
      overflow: hidden;
      img {
        @include wh(100%, 100%);
        object-fit: cover;
      }
    }
    .g-user-basic {
      h4 {
        @include sc(16px, #666);
        line-height: 30px;
      }
      p {
        @include sc(14px, #666);
        span {
          @include sc(14px, #0BABF7);
          margin-right: 10px;
        }
      }
    }
  }

  .g-info-box {
    margin-right: 40px;
    .g-info-item {
      border-left: 1px solid #ccc;
      height: 60px;
      text-align: center;
      /*padding: 0 40px;*/
      min-width: 164px;
      box-sizing: border-box;
      margin-top: 0;
      .p1 {
        @include sc(32px, #eb0609);
        text-align: center;
        margin-top: -15px;
      }
      .p2 {
        @include sc(14px, #333);
        text-align: center;
        margin-bottom: 5px;
      }
    }
  }

  .g-remindsbox {
    /*height: 600px;*/
    flex: 1;
    overflow: hidden;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
    .g-reminds-item {
      height: 100%;
      background-color: #fff;
      width: calc((100% - 20px) / 2);
      .g-reminds-tit {
        justify-content: space-between;
        @include wh(100%, 40px);
        border-bottom: 1px solid #dbdde5;
        background: #f3f8fc;
        .tit-left {
          margin-left: 20px;
          cursor: pointer;
          @include sc(16px, #3c5061);
          font-weight: 600;
          i {
            @include sc(18px, #3c5061);
            margin-right: 10px;
          }
        }
        .tit-right {
          margin-right: 20px;
          @include sc(14px, #7f8085);
          cursor: pointer;
          i {
            @include sc(14px, #333);
            margin-right: 10px;
          }
        }
      }
    }
  }

  .g-remind-cont {
    overflow: auto;
    padding: 10px;
    .g-cont-item {
      border-left: 8px solid #a1a1a1;
      padding-left: 10px;
      justify-content: space-between;
      height: 70px;
      background-color: #f9f9f9;
      padding-right: 10px;
      margin-bottom: 10px;
      .g-btn1 {
        background-color: #a1a1a1;
        color: #fff;
        font-size: 12px;
      }
      .g-item-left {
        width: calc(100% - 90px);
      }
    }
    .g-something {
      margin-top: 10px;
      h4 {
        @include sc(14px, #333);
        font-weight: bold;
        margin-left: 10px;
        width: calc(100% - 90px);
      }
      .g-type {
        background-color: #fff;
        border: 1px solid #169BD5;
        border-radius: 8px;
        line-height: 20px;
        @include sc(13px, #169BD5);
        padding: 0 10px;
      }
    }
    .g-contact-info {
      margin-top: 10px;
      p {
        margin-right: 20px;
        @include sc(12px, #666);
        i {
          @include sc(12px, #199ed8);
          margin-right: 10px;
        }
      }
      img {
        @include wh(17px, 17px);
        margin-top: -2px;
        margin-right: 4px;
      }
    }
    .c-ingcolor {
      border-left: 8px solid #199ed8;
      background-color: #e4f4fa;
      .g-btn1 {
        background-color: #169bd5;
        color: #fff;
      }
    }
    .g-examine-item {
      height: 48px;
      border: 1px solid $border-c;
      border-left: 8px solid #e6e6e6;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      .g-something {
        margin-top: 0;
        /*padding-left: 20px;*/
      }
    }
    .g-examine-item.c-ingcolor {
      border-left: 8px solid #169bd5;
      background-color: #fff;
    }
  }

  .g-notice-cont {
    padding: 10px;
    .g-notice-item {
      cursor: pointer;
      position: relative;
      box-sizing: border-box;
      border-bottom: 1px solid #f2f2f2;
      height: 50px;
      padding: 0 10px;
      &:hover {
        background-color: #e4f4fa;
      }
      .g-notice-tit {
        justify-content: space-between;
        h4 {
          margin-top: 10px;
          @include sc(14px, #333);
          font-weight: bold;
          width: calc(100% - 100px);
        }
        h4.g-fullwidth {
          font-weight: 400;
          color: #717171;
        }
        .p-times {
          @include sc(14px, #A1A1A1)
        }
      }
      .g-contss {
        @include sc(14px, #666);
        line-height: 40px;
      }
    }
    .g-worker-list {
      display: flex;
      flex-wrap: wrap;
      /*align-content: flex-start;*/
      padding-bottom: 10px;
      background: #f5f5f5;
      box-sizing: border-box;
      .g-worker-item {
        width: calc((100% - 40px) / 3);
        /*height: 90px;*/
        margin-left: 10px;
        margin-top: 10px;
        padding: 10px;
        box-sizing: border-box;
        background: #fff;
        border: 1px solid $border-c;
        border-radius: 5px;
        .worker-img {
          width: 55px;
          height: 55px;
        }
        .title {
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 10px;
        }
      }
    }
  }

  .dialog_form {
    padding: 20px;
  }

  .g-thing-tit {
    position: relative;
    border-bottom: 1px solid #cccccc;
    h4 {
      @include sc(14px, #333);
      line-height: 40px;
      font-weight: bold;
    }
    p {
      @include sc(12px, #606266);
      line-height: 30px;
      margin-right: 20px;
    }
    .thingstate {
      position: absolute;
      top: 0;
      right: -20px;
      @include wh(80px, 30px);
      background: #169bd5;
      border-radius: 15px 0 0 15px;
      text-align: center;
      line-height: 30px;
      @include sc(13px, #fff)
    }
    .c-blue {
      @include sc(13px, #1E1E1E);
      background-color: #d7d7d7;
    }
  }

  .g-contp {
    margin-top: 20px;
    line-height: 24px;
    @include sc(12px, #666);
    text-indent: 2em;
  }

  .g-uploadimgbox {
    padding: 10px;
    margin-top: 10px;
    background-color: #fff;
  }

  .weiduimg {
    @include wh(31px, 31px)
  }

  .g-fullwidth {
    width: 100%;
    color: #747474;
  }

  .g-nowidth {
    /*width: calc(100% - 80px);*/
    color: #363f48;
    font-weight: 700;
    flex: 1;
  }

  .g-downbox {
    background-color: #fff;
    padding: 20px;
    margin-bottom: 20px;
    .g-dowm-item {
      justify-content: space-around;
      margin-bottom: 10px;
    }
    .g-filename {
      width: 30%;
      padding-left: 20px;
      font-size: 13px;
      color: #333333;
    }
    .g-filetime {
      padding-left: 20px;
      font-size: 13px;
      color: #8f949a;
    }
    i {
      @include sc(16px, #ccc);
      cursor: pointer;
    }
  }

  .g-nodata {
    padding-top: 40px;
    text-align: center;
    img {
      @include wh(100px, 100px)
    }
    p {
      text-align: center;
      line-height: 40px;
      @include sc(14px, #0091ea)
    }
  }

  .pages {
    min-width: 1050px;
  }

  .aside-list {
    li {
      text-align: center;
      border-bottom: 4px solid rgba(255, 255, 255, 0);
      color: #999;
      margin-left: 20px;
      padding: 8px 15px;
      cursor: pointer;
      p {
        font-weight: 700;
        font-style: normal;
        font-size: 18px;
      }
    }
    li:hover {
      border-bottom: 4px solid #0066FF;
      color: #0066FF;
    }
    .active {
      border-bottom: 4px solid #0066FF;
      color: #0066FF;
    }
  }

  .icon {
    font-size: 16px;
    margin-right: 10px;
    color: #33ccff;
  }

  .img-icon {
    width: 25px;
    height: 25px;
  }

  .img-more-icon {
    width: 20px;
    height: 20px;
  }

  /*项目详情对话框样式*/

  .icon-shenqing {
    font-size: 40px;
    margin-right: 20px;
    color: #4FA3EC;
  }

  .g-content-wrap {
    height: 500px;
    display: flex;
  }

  .el-steps {
    padding: 0;
    width: 300px;
    min-width: 180px;
    max-height: 400px;
    background: #fff;
    box-shadow: none;
  }

  .el-step {
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: 150px !important
  }

  .g-right {
    width: 510px;
    margin-left: 20px;
    .g-right-top, .g-right-bottom {
      width: 100%;
      padding: 20px 30px;
      background: #fff;
      box-sizing: border-box;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      &.g-right-bottom {
        margin-top: 20px;
        height: 365px;
      }
      &.g-right-top {
        height: 115px;
      }
    }
  }

  .g-header {
    height: 100px;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }

  .g-body {
    height: 215px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .content {
      overflow: hidden;
      flex-grow: 1;
      padding-bottom: 10px;
    }
  }

  .carry-file {
    width: 100%;
    margin-bottom: 5px;
    color: #ccc;
    font-size: 16px;
    cursor: pointer;
  }

  .el-button--mini {
    width: 80px;
  }

  .el-pagination {
    text-align: center;
    margin-top: 30px;
  }

  .g-overflow {
    overflow-y: auto;
  }

  .g-fileName {
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 360px;
  }

  .g-right-top-desc {
    margin-top: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
  }

  .f-detail-link {
    text-decoration: underline;
    color: #009DD9;
    cursor: pointer;
  }

  .f-last-title {
    color: red;
  }

  .g-wrap {
    border-bottom: 1px solid $border-c;
    padding: 15px 30px;
    .g-title {
      font-weight: bold;
      margin-bottom: 15px;
    }
  }

  .s-read {
    color: #B1AEAE;
  }

  .g-danger {
    color: #fff;
    background: #fd5a31;
  }

  .g-examine {
    border-color: #73a7ca;
    color: #5b8db4;
  }

  .examine-btn {
    font-size: 12px !important;
    span {
      font-size: 12px !important;
    }
  }

  .user-img {
    width: 16px;
    height: 16px;
  }

  .download-icon {
    margin-left: 10px;
    font-size: 20px;
    font-weight: 700;
    color: #1296db;
    cursor: pointer;
  }

  .icon {
    font-size: 20px;
    font-weight: 600;
    margin-left: 10px;
    cursor: pointer;
  }

  .f-enter-type {
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 1px 10px 1px 20px;
    color: #fff;
    font-size: 14px;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 5px;
  }

  .f-enter-type.f-green {
    background: linear-gradient(to right, #49de20, #12d230);
  }

  .f-enter-type.f-blue {
    background: linear-gradient(to right, #20bae9, #1a9ce4);
  }

  .shortcut-btn {
    display: inline-block;
    white-space: nowrap;
    font-size: 12px;
    border: 1px solid #e5e5e5;
    border-radius: 20px;
    padding: 4px 20px;
  }
  .down-item{
    height: 28px;
    span{
      color: #3399FF;
    }
    i{
      cursor: pointer;
    }
  }

  @media screen and (min-width: 0) and (min-width: 1600px) {
    #app .g-worker-list {
      .g-worker-item {
        width: calc((100% - 40px) / 4);
      }
    }
  }

  @media screen and (min-width: 1920px) {
    #app .g-worker-list {
      .g-worker-item {
        width: calc((100% - 40px) / 4);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/企业工作台.vue